import {useState} from 'react'
import {FormItemProps, Input, InputProps} from 'antd'
import {FileInterface} from 'common/types'
import {
  // Text, 
  // IconButton, DotsIcon,
  Box, Button, 
  useForm, useWatch, Form, FormItem, Select, 
  UserPhoto as OrgPhoto,
  DatePicker,
  // UserAvatar
} from 'common/components'
import {FIELD_RULES, EMAIL_FIELD_RULES} from 'common/constants'
import {useCreateOrganisation, useUpdateOrganisation, OrgBase} from '..'
import { ExOrgType } from '../types'
import { formatDate } from 'common/helpers'

type EntityTypeValueType = 'Company' | 'Partnership' | 'Trust' | 'Individual';
const ORG_TYPE_VALUE_LABEL: Record<ExOrgType, string> = {
  'borrower': 'Borrower',
  'broker'  : 'Broker',
}
const ENTITY_TYPE_VALUE_LABEL: Record<EntityTypeValueType, string> = {
  'Company'    : 'Company',
  'Partnership': 'Partnership',
  'Trust'      : 'Trust',
  'Individual' : 'Individual',
}
const ORG_TYPE_OPTIONS = Object.keys(ORG_TYPE_VALUE_LABEL).map((key: string) => (
  { value: key, label: ORG_TYPE_VALUE_LABEL[key as ExOrgType] }
))
const ENTITY_TYPE_OPTIONS = Object.keys(ENTITY_TYPE_VALUE_LABEL).map((key: string) => (
  { value: key, label: ENTITY_TYPE_VALUE_LABEL[key as EntityTypeValueType] }
))

const VALID_LIST = {
  'companyNumber' : ['Company'],
  'nzbn'          : ['Company', 'Partnership', 'Trust'],
  'commenced'     : ['Company', 'Partnership', 'Trust'],
}


interface OrgFormProps {
  defaultOrgType?: 'borrower' | 'broker';
  initValues?: any;
  onClose: () => void
}

// const initialValues:any = {
//   role: 'user',
// }

const Field = ({name, type, ...props}: FormItemProps & InputProps) => (
  <FormItem
    {...props}
    name={name}
    rules={type === 'email' ? EMAIL_FIELD_RULES : FIELD_RULES}
  >
    <Input
      autoFocus={name === 'firstName'}
      type={type}
      addonBefore={name === 'phone' ? '+64' : undefined}
    />
  </FormItem>
)

export default function OrgDetailsForm({onClose, initValues, defaultOrgType}: OrgFormProps) {
  const [image, setImage] = useState<FileInterface>(
    !!initValues?.photo ? {url: initValues.photo} : {}
  )

  if (initValues?.commenced) {
    initValues.commenced = new Date(initValues.commenced)
  }

  const isVCTeam = (initValues?.type === 'team')
  const isVCEntt = (initValues?.entityType === 'vc')

  const [form] = useForm()
  const entityTypeValue = useWatch('entityType', form)
  // const orgTypeValue = useWatch('type', form)
  // console.log(orgTypeValue, entityTypeValue)

  const {mutate: createNewOrg, isMutating: isCreating} = useCreateOrganisation(onClose)
  const {mutate: updateTheOrg, isMutating: isUpdating} = useUpdateOrganisation(onClose)

  const isMutating = isCreating || isUpdating
  
  const handleFinish = (values: OrgBase) => {
    // console.log('to create', values)
    const data:any = {
      ...values, 
      phone: `+64${values.phone.trim()}`,
    }
    if (!!values.commenced) {
      data.commenced = formatDate(values.commenced, 'server')
    }
    if (image.uuid) {
      data.photo = image.uuid
    }
    // console.log('format data', data, initValues?.id)

    if (!!initValues?.id) {
      data.id = initValues.id
      updateTheOrg(data)
    } else {
      createNewOrg(data)
    }
  }

  // console.log(image)
  
  return (
    <Form form={form} initialValues={!initValues ? {
      type: defaultOrgType
    } : {
      ...initValues,
      phone: initValues.phone?.replace('+64', '') || ''
    }} onFinish={handleFinish}>
      <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', border: '', marginBottom: '40px'}}>
        {/* <UserAvatar size={120} src={initialValues.photo} alt={initialValues.firstName || 'avatar'} /> */}
        {/* <IconButton
          className={'DotsMenu-Button_light'}
          icon={<DotsIcon />}
          aria-label="avatar"
        /> */}
        <div>
          <OrgPhoto image={image} setImage={setImage} />
          {/* { !!image?.uuid &&
            <UserAvatar size={120} src={image.uuid} alt={'avatar'} />
          } */}
        </div>
      </div>
      { !isVCTeam && 
        <FormItem name="type" 
          label="Organisation Type" 
          rules={FIELD_RULES}
        >
          <Select placeholder="Please select"
            options={ORG_TYPE_OPTIONS}
          />
        </FormItem>
      }
      <Field name="name" label="Organisation Name" />
      { !isVCEntt &&
        <FormItem name="entityType" 
          label="Entity Type" 
          rules={FIELD_RULES}
        >
          <Select placeholder="Please select"
            options={ENTITY_TYPE_OPTIONS}
          />
        </FormItem>
      }
      { VALID_LIST['nzbn'].includes(entityTypeValue) &&
        <Field name="nzbn" label="NZBN" />
      }
      { VALID_LIST['companyNumber'].includes(entityTypeValue) &&
       <Field name="companyNumber" label="Company NO." />
      }
      { VALID_LIST['commenced'].includes(entityTypeValue) &&
        <FormItem name="commenced"  label="Commenced" rules={FIELD_RULES}>
          <DatePicker
            // format="DD/MM/y"
            disabledDate={(v:Date) => !v}
          />
        </FormItem>
      }
      <Field name="email"         label="Contact Email" type="email" />
      <Field name="phone"         label="Contact Phone number" />
      <Field name="address"       label="Address" />

      <div style={{height: '32px'}}></div>
      <Box mt={12}>
        <Button block htmlType="submit" loading={isMutating}>
          SAVE
        </Button>
      </Box>
    </Form>
  )
}
